import { FC } from "react";

import { useTranslation } from "react-i18next";

import { useCart } from "@hooks/useCart";

import Badge from "@mui/material/Badge";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";

import { appLayoutDimensions } from "../../../../AppLayout.constants";

import { ICartHeaderProperties } from "./CartHeader.types";

const CartHeader: FC<ICartHeaderProperties> = ({ onClose }) => {
  const { t } = useTranslation();
  const { data: cart } = useCart();

  const itemCount = cart?.lines.reduce((count, line) => count + line.quantity, 0) ?? 0;

  return (
    <Box
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        height: appLayoutDimensions.headerHeight,
        flexShrink: 0,
        pl: 1,
        pr: 3,
        bgcolor: "background.default",
        color: "text.primary",
        borderBottom: 1,
        borderColor: "divider",
      }}
    >
      <Button
        color="inherit"
        size="small"
        startIcon={<KeyboardBackspaceIcon />}
        onClick={onClose}
        data-amp-default-track={true}
        data-amp-event-type="cart.button.backButton"
      >
        {t("cartSidebar.backButton")}
      </Button>
      <Badge badgeContent={itemCount} color="primary">
        <ShoppingCartOutlinedIcon />
      </Badge>
    </Box>
  );
};

export default CartHeader;
